<!-- Topbar trigger — looks like a search field, opens the spotlight. -->
<button type="button" class="gs-trigger" (click)="openSearch()" aria-label="Search (Ctrl+K)">
  <i class="pi pi-search"></i>
  <span class="gs-trigger-label">Search</span>
  <kbd class="gs-kbd">Ctrl K</kbd>
</button>

@if (open()) {
  <div class="gs-backdrop" (click)="close()"></div>

  <div class="gs-panel" role="dialog" aria-modal="true" aria-label="Global search">
    <div class="gs-input-row">
      <i class="pi pi-search"></i>
      <input #box type="text" placeholder="Search pages and actions…" autocomplete="off"
        spellcheck="false" [ngModel]="query()" (ngModelChange)="onQuery($event)"
        (keydown)="onKey($event)" />
      <kbd class="gs-kbd" (click)="close()">Esc</kbd>
    </div>

    <div class="gs-list" role="listbox">
      @if (!rows().length && !dataLoading()) {
        <div class="gs-empty">
          <i class="pi pi-compass"></i>
          <p>No matches for “{{ query() }}”</p>
          <small>Try a page name, a member id / mobile, or a payment id.</small>
        </div>
      }

      @for (r of rows(); track r.group + r.route + r.title + (r.sub ?? ''); let i = $index) {
        @if (i === 0 || rows()[i - 1].group !== r.group) {
          <div class="gs-group">{{ r.group }}</div>
        }
        <button type="button" class="gs-item" [class.active]="i === active()"
          role="option" [attr.aria-selected]="i === active()"
          (mouseenter)="active.set(i)" (click)="go(r)">
          <span class="gs-icon"><i [class]="r.icon"></i></span>
          <span class="gs-text">
            @if (parts(r.title); as p) {
              <span class="gs-title">{{ p.pre }}@if (p.hit) {<mark>{{ p.hit }}</mark>}{{ p.post }}</span>
            }
            @if (r.sub) { <small class="gs-sub">{{ r.sub }}</small> }
            @else if (r.path) { <small class="gs-path">{{ r.path }}</small> }
          </span>
          @if (isLocked(r)) {
            <i class="pi pi-lock gs-side" title="KYC approval required"></i>
          } @else {
            <i class="pi pi-arrow-right gs-side gs-go"></i>
          }
        </button>
      }

      @if (dataLoading()) {
        <div class="gs-searching"><i class="pi pi-spin pi-spinner"></i> Searching members &amp; payments…</div>
      }
    </div>

    <div class="gs-foot">
      <span><kbd class="gs-kbd">↑</kbd><kbd class="gs-kbd">↓</kbd> navigate</span>
      <span><kbd class="gs-kbd">↵</kbd> open</span>
      <span><kbd class="gs-kbd">Ctrl K</kbd> toggle</span>
    </div>
  </div>
}
